<template>
    <textarea v-model="innerValue" :rows="rows"></textarea>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: null
            }
        },
        computed: {
            rows: function () {
                const num = 0;
                if (this.value) {
                    const num = this.value.split("\n").length;
                }
                return (num > 4) ? num : 4;
            },
            innerValue: {
                get: function () {
                    return this.value;
                },
                set: function (val) {
                    this.$emit('input', val);
                }
            }
        },
    }
</script>
